import axios from 'axios';

const request = axios.create({
    baseURL: 'https://youtube.googleapis.com/youtube/v3',
    params:{
        // key: process.env.REACT_API_UTUBE_KEY,
        // key:"AIzaSyDj-7HU3DSGVBI0GE9VX7ivnVKwvSOs3Qc",
        //key:"AIzaSyB2cL_2rsnGMVHsAycBvgOLR8ioqL6DTz4",
        key:"AIzaSyC27QRceGaWabrMAPeTkeSxP8l_9X7etBY"
    }
})

export default request;